import { useTranslations } from "@i18n/next";
import { Button, colors, useConfirm } from "@packages/ui";

export const useConfirmRemovePostDialog = () => {
  const t = useTranslations();
  return useConfirm({
    cancelButton: t("general_word_cancel"),
    description: () => t("community_delete_confirmation_message"),
    primaryButton: (onClick) => (
      <Button variant="color" color={colors.red60} onClick={onClick}>
        {t("community_remove_post_action")}
      </Button>
    ),
    title: () => t("community_moderation_confirm_delete"),
  });
};
